var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrendingDown = function SvgTrendingDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.293 6.293a1 1 0 0 1 1.414 0l4.869 4.869c.21.21.325.323.414.4l.01.008.01-.009c.09-.076.205-.19.414-.4l2.76-2.76c.179-.178.352-.352.511-.487.175-.148.397-.308.687-.402a2 2 0 0 1 1.236 0c.29.094.512.254.687.402.159.135.332.31.51.488L21 14.586V10a1 1 0 1 1 2 0v7a1 1 0 0 1-1 1h-7a1 1 0 1 1 0-2h4.586l-6.162-6.162a8 8 0 0 0-.414-.4L13 9.43l-.01.009c-.09.076-.205.19-.414.4l-2.76 2.76a9 9 0 0 1-.512.487 2 2 0 0 1-.686.402 2 2 0 0 1-1.236 0 2 2 0 0 1-.686-.402 9 9 0 0 1-.512-.488l-.022-.022-4.87-4.869a1 1 0 0 1 0-1.414",
    clipRule: "evenodd"
  })));
};
export default SvgTrendingDown;